import { Template } from '@bynder-studio/render-core';
import { gatewayClient, createService } from './connectors/httpClient';

const httpClient = gatewayClient('/templates');

const templatesServiceFromXML = createService(httpClient, (client) => ({
    uploadTemplate(formData: FormData) {
        return client.post<Template>(`/xml/convert?mapAssets=true`, formData);
    },
}));

export default templatesServiceFromXML;
